export type LeftPaneTab = "note" | "chart_history";

export function countWords(text: string): number {
  const trimmed = text.trim();
  return trimmed.length > 0 ? trimmed.split(/\s+/).length : 0;
}

export function countLines(text: string): number {
  const trimmed = text.trim();
  return trimmed.length > 0 ? trimmed.split("\n").length : 0;
}

export function getLeftPaneTitle(activeTab: LeftPaneTab): string {
  return activeTab === "note" ? "Current Note" : "Smart Chart";
}

export function getHeaderTabClassName(isActive: boolean): string {
  return isActive
    ? "px-3 py-1.5 text-xs font-semibold rounded-full border bg-white text-purple-800 border-white"
    : "px-3 py-1.5 text-xs font-semibold rounded-full border bg-transparent text-white border-white";
}

export function getNoteToggleLabel({
  isOpen,
  isPrecharting,
}: {
  isOpen: boolean;
  isPrecharting: boolean;
}): string {
  if (isOpen) {
    return isPrecharting ? "Hide Smart Chart" : "Hide Note";
  }
  return isPrecharting ? "View Smart Chart" : "View Current Note";
}
